// src/component/PaginaRevista/imagenesRevista.js
function importAll(r) {
  return r.keys().map(r);
}

export const imagenesRevista = importAll(
  require.context('../../assets/revista', false, /\.(png|jpe?g|svg)$/)
);